import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import "./Home.css";

function Home() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          } else {
            entry.target.classList.remove("visible");
          }
        });
      },
      { threshold: 0.2 }
    );

    const sections = document.querySelectorAll(".info-section, .cta-section");
    sections.forEach((sec) => observer.observe(sec));

    return () => observer.disconnect();
  }, []);

  const sections = [
    {
      title: "Recycled | Liquidation | New Turf | Calimesa",
      text:
        "Calimesa Turf Center by Graystone Construction (DBA Graystone Enterprises Inc.). Licensed C-27 Landscape Contractors offering recycled, liquidation, and new artificial grass by the roll, plus full-service landscape design and installation.",
    },
    {
      title: "Licensed, Bonded & Insured Landscape Contractors",
      text:
        "We are Licensed C-27 Landscape Contractors with licensed Home Improvement Salespersons (HIS) through the California Contractors State License Board (CSLB). Bonded and insured to handle any size project — from small residential yards to large commercial installations.",
    },
    {
      title: "Turf Sales for DIY & Licensed Contractors",
      text:
        "Buy recycled, liquidation, or new turf rolls for your own DIY project, or as a licensed contractor. Recycled turf is heavy and must be reviewed on-site by appointment. A suitable pickup (truck or trailer) is required. Licensed contractors with an ACTIVE CSLB license receive 5% off recycled turf when they present their active CSLB license at pickup.",
    },
    {
      title: "Free Estimates for Turf & Full Landscape Design",
      text:
        "Call us for a FREE estimate on your next turf project or complete landscape design. We handle demolition, grading, base prep, turf installation, drainage, irrigation adjustments, and finishing touches so your project looks professional and is built to last.",
    },
    {
      title: "Calimesa Turf Center — Access & Appointments",
      text: (
        <>
          Recycled turf inventory changes weekly — all visits and pickups are by <strong>appointment only</strong>. Delivery is available for an additional fee and only upon availability. <br /><br />
          <strong>Location:</strong> Calimesa, California (exact address provided with confirmed appointment). <br />
          <strong>Phone (Call/Text):</strong>{" "}
          <a href="tel:+16197611113">+1 (619) 761-1113</a>
        </>
      ),
    },
  ];

  return (
    <div className="home-container">
      <Helmet>
        <title>Calimesa Turf Center — Recycled, Liquidation & New Turf</title>
        <meta
          name="description"
          content="Calimesa Turf Center by Graystone Construction — Licensed C-27 Landscape Contractors selling recycled, liquidation, and new artificial turf, plus full landscape design and installation. Free estimates for turf projects and full landscapes. DIY pickup and contractor discounts available."
        />
      </Helmet>

      {/* Hero Section */}
      <section className="hero-section">
        <video
          className="hero-video"
          autoPlay
          loop
          muted
          playsInline
          poster="/logo512.png"
        >
          <source src="/banner.mp4" type="video/mp4" />
          Your browser doesn’t support HTML5 video.
        </video>
        <div className="hero-overlay animate-fadeInUp">
          <div className="overlay-content">
            <h1>{sections[0].title}</h1>
            <p>{sections[0].text}</p>
          </div>
        </div>
      </section>

      {/* Info Sections */}
      {sections.slice(1, 4).map((section, idx) => (
        <section
          key={idx}
          className={`info-section animate-fadeInUp`}
        >
          <div className="info-box">
            <h2>{section.title}</h2>
            <p>{section.text}</p>
          </div>
        </section>
      ))}

      {/* Access & Transport / CTA Section */}
      <section className="cta-section animate-fadeInUp">
        <h2>{sections[4].title}</h2>
        <div className="cta-text">{sections[4].text}</div>
        <div className="cta-buttons" style={{ marginTop: "1rem" }}>
          <a className="btn btn-primary" href="tel:+16197611113">Call 24/7</a>
          <a className="btn btn-secondary" href="https://maps.google.com/?q=Calimesa%2C%20CA" target="_blank" rel="noopener noreferrer">Get Directions</a>
        </div>
      </section>
    </div>
  );
}

export default Home;